import React, {useState, useEffect, useMemo} from 'react';
import deliveryIcon from "../assets/images/delivery-icon.png";
import Strings from "../Lang/strings";
import swal from '../utils/swal'
import ScheduleParser from "../utils/ScheduleParser";
import BannerWrapper from "./BannerWarrper";

const TimingStep = ({schedule, expectedTime, expectedDate, dataChangeHandler, submitAddress}) => {
        //todo refactor
        const [selectedDayIndex, setSelectedDayIndex] = useState(0);
        const [selectedHourIndex, setSelectedHourIndex] = useState(0);
        useEffect(() => {
            submitAddress();
        }, []);
        const parsedSchedule = useMemo(() => {
            if (schedule) {
                const parsedSchedule = (new ScheduleParser(schedule.days)).handle();
                //checking if there is already saved expected date and time;
                if (expectedDate) {
                    let indexOfExpectedDate = 0;
                    let expectedDateObject;
                    let indexOfExpectedTime = 0;
                    parsedSchedule.forEach((date, index) => {
                        if (date.dateString === expectedDate) {
                            indexOfExpectedDate = index;
                            expectedDateObject = date;
                        }
                    });
                    if (expectedDateObject) {
                        let selectedHour = expectedTime.substr(0, 2);
                        selectedHour = parseInt(selectedHour);
                        expectedDateObject.hours.forEach((hoursArray, index) => {
                            if (hoursArray[0] == selectedHour) {
                                indexOfExpectedTime = index;
                            }
                        });
                        if (indexOfExpectedTime === 0) {
                            dataChangeHandler("expected_time", `${parsedSchedule[0].hours[0][0]}:00`);
                        }
                        setSelectedHourIndex(indexOfExpectedTime);
                        setSelectedDayIndex(indexOfExpectedDate);
                    } else {
                        dataChangeHandler("expected_date", parsedSchedule[0].dateString);
                        dataChangeHandler("expected_time", `${parsedSchedule[0].hours[0][0]}:00`)
                    }
                } else {
                    dataChangeHandler("expected_date", parsedSchedule[0].dateString);
                    dataChangeHandler("expected_time", `${parsedSchedule[0].hours[0][0]}:00`)
                }
                return parsedSchedule;
            }
        }, [schedule])
        window.parsed = parsedSchedule;
        if (!schedule) {
            return null;
        }
        if (!schedule.days) {
            return swal("لا توجد اوقات توصيل متوفرة حاليا").then(_ => {
                document.reload();
            })
        }
        const formatSelectedHour = ScheduleParser.toAmPm(parsedSchedule[selectedDayIndex].hours[selectedHourIndex][0]);
        return (
            <div className={"flex justify-center items-center mt-12 mb-2 flex-col w-22"}>
                <img className={"w-12 lg:w-20 md-16"} src={deliveryIcon} alt="map icon"/>
                <h1 className={"text-center capitalize  mt-1 text-gray-900  lg:text-2xl text-lg"}>{Strings.selectTheDeliveryTime}</h1>
                <BannerWrapper/>
                <h2 className={"text-gray-700  mt-2"}>{parsedSchedule[selectedDayIndex].displayDate} {formatSelectedHour}</h2>
                {/*<div className="bg-gray-400 w-80 mb-1 lg:mb-2 md:mb-2 h-px mt-1"/>*/}
                <div className={"bg-white rounded-2xl lg:h-72 md:h-72  h-64 flex w-full"}>
                    <div id={"hours"} className={"overflow-y-scroll py-3 p-2 flex-1"}>
                        {
                            parsedSchedule[selectedDayIndex].hours.map((hoursArray, index) => <button
                                style={{direction: "initial"}} key={index}
                                onClick={() => {
                                    setSelectedHourIndex(index)
                                    dataChangeHandler("expected_time", `${hoursArray[0]}:00`)
                                }}
                                className={`${index === selectedHourIndex ? "text-zain-primary   border-2 border-zain-primary" : "text-gray-400"} text-xss px-7 md:text-sm  transition date-button`}>
                                {`${ScheduleParser.toAmPm(hoursArray[0])} - ${ScheduleParser.toAmPm(hoursArray[1])}`}
                            </button>)
                        }

                    </div>
                    <div className={"border  border-gray-400 my-5 opacity-40 lg:border-0"}/>
                    <div id={"dates"} className={"flex-1 py-3 p-2 overflow-y-scroll"}>
                        {
                            parsedSchedule.map((date, index) => <button key={index}
                                                                        onClick={() => {
                                                                            setSelectedHourIndex(0)
                                                                            setSelectedDayIndex(index)
                                                                            dataChangeHandler("expected_date", date.dateString)
                                                                            dataChangeHandler("expected_time", `${date.hours[0][0]}:00`)
                                                                        }}
                                                                        className={`${index === selectedDayIndex ? "text-zain-primary   border-2 border-zain-primary" : "text-gray-400"} px-11 transition text-xss md:text-sm date-button`}>
                                {date.displayDate}
                            </button>)
                        }


                    </div>
                </div>
            </div>
        );
    }
;

export default TimingStep;
